
import _ from "@/boot/lodash";
import Vue, { RenderContext } from "vue";
export default Vue.extend({
  name: "UCouponCodes",
  functional: true,
  render(h, context: RenderContext) {
    _.set(context.data, "[class][u-coupon-codes]", true);
    return h("div", context.data, context.children);
  }
});
